import { Card, Col, notification, Row, Select, Space, Tag } from "antd";
import {
  daysJsFormat,
  formatCurrency,
  languagesList,
  renderDiplomas,
  renderLevel,
  renderUserGenderShort,
  renderUserName,
  roles,
  statusOption,
  statusPrestationsValues,
  typeIntervention,
} from "../../../utils/constants";
import {
  changeStatusInterprete,
  setPrestation,
  setSelectedInterprete,
} from "../Slices/Prestation.slice";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import {
  confirmRelanceInterpreteInvitation,
  manuelAttributeInterprete,
} from "../../../shared/components/Modals/modals";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import { http } from "../../../engine/api/http";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export const prestationInterpretesColumns = prestation => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useContext(UserContext);

  const byStatus = value => {
    if (
      prestation.status === statusPrestationsValues.draft &&
      value === "relance"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "position",
      rowScope: "row",
      key: "position",
      width: "30px",
      render: (position, record) => (
        <>
          <Tag className={"largeTag"} size={"large"} color={"red"}>
            {record.position}
          </Tag>
        </>
      ),
    },
    {
      title: t("prestationInterpretesColumns.interpreter"),
      width: "120px",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <strong>{renderUserName(record.interprete)}</strong>
      ),
    },
    {
      title: t("prestationInterpretesColumns.genre"),
      dataIndex: "genre",
      key: "genre",
      width: "40px",
      render: (g, record) => renderUserGenderShort(record.interprete),
    },

    {
      title: t("prestationInterpretesColumns.level"),
      dataIndex: "levels",
      key: "levels",
      width: "100px",
      render: (text, record) => <span>{renderLevel(record?.interprete)} </span>,
    },
    {
      title: t("prestationInterpretesColumns.interpretedLanguages"),
      dataIndex: "interpreteData",
      key: "interpreteData",
      width: "150px",
      render: (interpreteData, record) =>
        record.interprete.interpreteData.languages.map(lang => (
          <Tag size={"middle"} className={"greyTag"}>
            {languagesList().find(e => e.value === lang)?.label}
          </Tag>
        )),
    },
    {
      title: t("prestationInterpretesColumns.travelExpenses"),
      dataIndex: "cost",
      key: "cost",
      width: "100px",
      render: (cost, record) => {
        return (
          <span>
            {typeIntervention.in_person === prestation.intervention.type
              ? formatCurrency(cost)
              : 0}
          </span>
        );
      },
    },
    {
      title: t("prestationInterpretesColumns.actionAndOrder"),
      dataIndex: "action",
      key: "action",
      width: "150px",
      render: (text, record) => {
        const deepCopy = JSON.parse(JSON.stringify(record.emailsSent));
        let last = null;
        if (deepCopy !== null) {
          const emails = deepCopy.sort((a, b) => {
            return new Date(b.send_at) - new Date(a.send_at);
          });

          last = emails ? emails[0] : null;
        }

        return (
          <Space direction={"vertical"}>
            <Select
              disabled={
                prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting
              }
              key={record._id + record.status}
              value={record.status}
              style={{ width: 160 }}
              onChange={newValue => {
                if (newValue === "selected") {
                  manuelAttributeInterprete({
                    onOk: async () => {
                      await dispatch(
                        setSelectedInterprete(record.interprete._id),
                      );
                      await dispatch(
                        changeStatusInterprete({
                          _id: record.interprete._id,
                          status: newValue,
                        }),
                      );
                    },
                    content: {
                      record,
                    },
                  });
                } else if (newValue === "relance") {
                  confirmRelanceInterpreteInvitation({
                    content: {
                      user: record.interprete,
                    },
                    onOk: async () => {
                      try {
                        const sendDirectEmail = await http.post(
                          `/prestations/${prestation._id}/relance/${record.interprete._id}`,
                        );

                        await dispatch(setPrestation(sendDirectEmail.data));
                        notification.success({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentSuccess",
                          ),
                        });
                      } catch (e) {
                        notification.error({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentError",
                          ),
                        });
                      }
                    },
                  }).then(() => {
                    console.log("then");
                  });
                } else {
                  dispatch(
                    changeStatusInterprete({
                      _id: record.interprete._id,
                      status: newValue,
                    }),
                  );
                }
              }}
              popupClassName={"colorfull"}
              className={"colorfull"}
            >
              {statusOption()
                .filter(e => {
                  if (user.role === roles.institution) {
                    return (
                      e.value !== "selected" &&
                      e.value !== "not_available" &&
                      e.value !== "relance"
                    );
                  } else {
                    return true;
                  }
                })
                .map(option => (
                  <Select.Option
                    key={option?.value}
                    value={option?.value}
                    disabled={
                      option?.disabled || false || byStatus(option?.value)
                    }
                  >
                    {option?.label()}
                  </Select.Option>
                ))}
            </Select>
            {last !== null && (
              <cite>
                {t("prestationInterpretesColumns.lastEmailSentOn")}{" "}
                {dayjs(last.send_at).format(daysJsFormat.full)}
              </cite>
            )}
          </Space>
        );
      },
    },
  ];
  return columns;
};

export const expandedRowRenderDetailInterpretes = props => {
  const { interprete, driving } = props;
  const { formations, country, lastDateFormation } = interprete.interpreteData;
  return (
    <div>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Card>
            <Row gutter={[5, 5]}>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  {t("prestationInterpretesColumns.coursesTaken")}
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {formations}
                </span>
              </Col>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  {t("prestationInterpretesColumns.lastFollowUpDate")}
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {lastDateFormation !== null || lastDateFormation !== ""
                    ? dayjs(lastDateFormation).format(daysJsFormat.full)
                    : ""}
                </span>
              </Col>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  {t("prestationInterpretesColumns.qualifications")}
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {renderDiplomas(interprete)}
                </span>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
